import { z } from 'zod';
import { SweetShopArticleCategoryModelSchema } from 'entities/sweet-shop-article-category';
import { GetSweetShopArticleCategoriesApiResponseSchema } from '../store';

export const createSweetShopArticleCategoriesFromGetSweetShopArticleCategoriesApiResponse = (
    (response: z.infer< typeof GetSweetShopArticleCategoriesApiResponseSchema>) => (
        response.data?.map(({
            slug,
            name,
            description,
            image,
        }) => (
            SweetShopArticleCategoryModelSchema.parse({
                uid: slug,
                name,
                description,
                image: image && {
                    url: image.url,
                },
            })
        ))
    )
);
